import { Dispatch, SetStateAction } from 'react'

import { SharedModalProps } from '@Components/Modal'
import { PersonalizationOptions } from '@Components/Product/ProductTypes'
import { Product, ProductVariant } from '@Generated/graphql'

export interface ProductPersonalization extends Omit<ProductVariant, '__typename'> {
  __typename: 'Product' | undefined
  masterVariant: PersonalizationOptions
  primaryAsset: {
    __typename: 'Asset' | undefined
    url: string
  }
}

export interface Personalization {
  id: string | number
  image: string
  maxCharacters: number | undefined
  placement: Record<string, string>
  price: string
  type: string
}

export type PersonalisationModalTypes = 'deboss' | 'engrave' | 'uv-print'

export interface PersonalisationModal extends SharedModalProps {
  additionalIDs?: string[]
  currentModal?: string | null
  isChildOfModal?: boolean
  product: Product
  setState?: Dispatch<SetStateAction<any>>
  updateProduct?: boolean
}

export const personalizationTranslationKeys = {
  engrave: 'products:PERSONALISATION_CAPTION_ENGRAVE',
  'engrave-button': 'products:LASER_ENGRAVE',
  'uv-print': 'products:PERSONALISATION_CAPTION_UV',
  'uv-print-button': 'products:PERSONALISED_UV_PRINTING',
  deboss: 'products:PERSONALISATION_CAPTION_DEBOSS',
  'deboss-button': 'products:DEBOSSING',
}
const personalizationTranslationHeader = {
  engrave: 'products:PERSONALISED_ENGRAVING',
  'uv-print': 'products:PERSONALISED_UV_PRINTING',
  deboss: 'products:PERSONALISED_DEBOSSING',
}

export const getPersonalizationTranslationHeader = (product: { masterVariant: PersonalizationOptions }) => {
  const { key } = product.masterVariant.type.value
  return personalizationTranslationHeader[key]
}
